import React from 'react'
import "../Header.scss"

function Header() {
  return (
    <div className="cptpl_logo h-20 rounded-b-3xl bg-lightPurple flex justify-center items-center headeriphone max-w-[500px] mx-auto">
        <img className='w-28 h-10' src={require('../../Assets/wap/zainIraqS4W/app_text.png')}></img>
    </div>
  )
}

export default Header